import * as AsciinemaPlayer from 'asciinema-player';

const player = AsciinemaPlayer.create('/demo.cast', document.getElementById('demo'), {
    rows: 24,
    poster: 'npt:0:6',
    autoPlay: true,
    loop: true,
    markers: [
      [1, 'Analyze'],
      [10, 'Run'],
    ]

  });
